module.exports = __webpack_public_path__ + "static/media/Intruded tooth 5.73d3cf4f.png";